import { render, staticRenderFns } from "./FbFileViewLink.vue?vue&type=template&id=33d188ec"
import script from "./FbFileViewLink.vue?vue&type=script&lang=js"
export * from "./FbFileViewLink.vue?vue&type=script&lang=js"
import style0 from "./FbFileViewLink.vue?vue&type=style&index=0&id=33d188ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports